"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
var _InputMessage = _interopRequireDefault(require("../InputMessage"));
var S = _interopRequireWildcard(require("./styles/Select.style"));
var DropdownMenu = _interopRequireWildcard(require("@radix-ui/react-dropdown-menu"));
var _excluded = ["children", "error", "errorMessage", "helper", "id", "label", "onChange", "placeholder", "dettath", "disabled"],
  _excluded2 = ["value", "text", "item", "handleMouseDown"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.608 10.258a.952.952 0 0 0-1.351.047.964.964 0 0 0 .047 1.358l7.544 7.079a.952.952 0 0 0 1.304 0l7.544-7.079a.964.964 0 0 0 .047-1.358.952.952 0 0 0-1.35-.047L14.5 16.725l-6.892-6.467z"
  }));
};
ArrowDown.defaultProps = {
  fill: "currentColor",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconError = function IconError(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 14c0 6.627-5.373 12-12 12S2 20.627 2 14 7.373 2 14 2s12 5.373 12 12zm-1.6 0c0-5.744-4.656-10.4-10.4-10.4C8.256 3.6 3.6 8.256 3.6 14c0 5.744 4.656 10.4 10.4 10.4 5.744 0 10.4-4.656 10.4-10.4zm-11.2 6.2v-1.4a.8.8 0 0 1 1.6 0v1.4a.8.8 0 0 1-1.6 0zm0-4V7.8a.8.8 0 0 1 1.6 0v8.4a.8.8 0 0 1-1.6 0z"
  }));
};
IconError.defaultProps = {
  fill: "currentColor",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg"
};
var Select = function Select(_ref) {
  var children = _ref.children,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    helper = _ref.helper,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? (0, _utils.createID)() : _ref$id,
    label = _ref.label,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    dettath = _ref.dettath,
    disabled = _ref.disabled,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)({
      text: '',
      value: ''
    }),
    _useState2 = _slicedToArray(_useState, 2),
    item = _useState2[0],
    setItem = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    open = _useState4[0],
    setOpen = _useState4[1];
  var triggerRef = (0, _react.useRef)(null);
  var handleChange = (0, _react.useCallback)(function (_ref2) {
    var event = _ref2.event,
      text = _ref2.text,
      value = _ref2.value;
    event.persist();
    var modifiedEvent = _objectSpread(_objectSpread({}, event), {}, {
      target: _objectSpread(_objectSpread({}, event.target), {}, {
        text: text,
        value: value
      })
    });
    onChange(modifiedEvent);
    setItem(function () {
      return {
        text: text,
        value: value
      };
    });
  }, [onChange]);
  var handleMouseDown = (0, _react.useCallback)(function (value, text, event) {
    handleChange({
      value: value,
      text: text,
      event: event
    });
  }, [handleChange]);
  var itemSelected = (0, _react.useMemo)(function () {
    var _children$find;
    if (!Array.isArray(children)) {
      return null;
    }
    return ((_children$find = children.find(function (itemChildren) {
      var _itemChildren$props;
      return (_itemChildren$props = itemChildren.props) === null || _itemChildren$props === void 0 ? void 0 : _itemChildren$props.selected;
    })) === null || _children$find === void 0 ? void 0 : _children$find.props) || null;
  }, [children]);
  (0, _react.useEffect)(function () {
    setItem({
      text: (itemSelected === null || itemSelected === void 0 ? void 0 : itemSelected.text) || '',
      value: (itemSelected === null || itemSelected === void 0 ? void 0 : itemSelected.value) || ''
    });
  }, [itemSelected]);
  return /*#__PURE__*/_react["default"].createElement(S.Container, props, label && /*#__PURE__*/_react["default"].createElement(S.Label, {
    htmlFor: id,
    error: error
  }, label), /*#__PURE__*/_react["default"].createElement(DropdownMenu.Root, {
    modal: false
  }, /*#__PURE__*/_react["default"].createElement(S.DropdownMenuTrigger, {
    id: id,
    className: error ? 'error' : '',
    ref: triggerRef,
    "data-testid": "menu-trigger",
    disabled: disabled
  }, item.text || placeholder, /*#__PURE__*/_react["default"].createElement(S.Arrow, {
    as: ArrowDown,
    disabled: disabled
  }), /*#__PURE__*/_react["default"].createElement(S.InputControl, {
    disabled: disabled,
    type: "text",
    initialValue: item.value,
    onFocus: function onFocus() {
      setOpen(true);
    },
    onBlur: function onBlur() {
      setOpen(false);
    },
    id: id,
    readOnly: true
  })), /*#__PURE__*/_react["default"].createElement(S.DropdownMenuContent, {
    open: open,
    sideOffset: 0,
    style: {
      width: triggerRef.current ? "".concat(triggerRef.current.offsetWidth, "px") : 'auto',
      minWidth: '100%',
      maxWidth: '100%'
    }
  }, _react["default"].Children.map(children, function (child) {
    if ( /*#__PURE__*/_react["default"].isValidElement(child)) {
      return /*#__PURE__*/_react["default"].cloneElement(child, {
        item: item,
        handleMouseDown: handleMouseDown
      });
    }
    return child;
  }))), helper && !errorMessage && /*#__PURE__*/_react["default"].createElement(_InputMessage["default"], {
    color: "text-light"
  }, helper), errorMessage && /*#__PURE__*/_react["default"].createElement(_InputMessage["default"], {
    color: "error"
  }, /*#__PURE__*/_react["default"].createElement(IconError, null), " ", errorMessage));
};
var Item = /*#__PURE__*/_react["default"].memo(function (_ref3) {
  var value = _ref3.value,
    text = _ref3.text,
    item = _ref3.item,
    handleMouseDown = _ref3.handleMouseDown,
    props = _objectWithoutProperties(_ref3, _excluded2);
  var active = value ? value === item.value : text === item.text;
  return /*#__PURE__*/_react["default"].createElement(S.DropdownMenuItem, _extends({
    className: active ? 'active' : '',
    onClick: function onClick(event) {
      return handleMouseDown(value, text, event);
    }
  }, props), text);
});
Select.Item = Item;
var _default = exports["default"] = Select;